// extracted by mini-css-extract-plugin
module.exports = {"container":"_28l6y","label":"_4TZ8I","spacing":"_3rK5T","tooltip":"_2ZSAi"};